<template>
<div class="chapter">
<div class="inner_page">
<div id="Chapter01">
<p class="fm-title"><a id="page_6"></a><a id="page_7"><b>CHAPTER 1 – OVERVIEW</b></a></p><a id="page_7">
<p class="h1" id="h1.1"><span class="line"><b>GENERAL INFORMATION</b></span></p>
<p class="h2a"><b>Population – European Union – Top Five Nations</b></p>
<p class="noindent1">(<i>2015 Official national estimates</i>)</p>
<div class="table1">
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup>
<col width="25%"/>
<col width="75%"/>
</colgroup>
<tbody>
<tr>
<td align="left" valign="top"><p class="table-para">Germany</p></td>
<td align="left" valign="top"><p class="table-para1">81.1 million</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">France</p></td>
<td align="left" valign="top"><p class="table-para1">64.3 million</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">United Kingdom</p></td>
<td align="left" valign="top"><p class="table-para1">64.5 million</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Italy</p></td>
<td align="left" valign="top"><p class="table-para1">61.0 million</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Spain</p></td>
<td align="left" valign="top"><p class="table-para1">46.3 million</p></td>
</tr>
</tbody>
</table>
</div>
<p class="noindent1">Total European Union population is estimated at 507 million. For comparison other population estimates include: China 1,350 million; India 1,250 million; United States 321 million and Russia 144 million.</p>
<p class="noindent"><b>Finance – European Union – Top Five Nations</b> (2015 IMF Estimates)</p>
<p class="noindent1"><i>In billions of US$; Euros and UK £</i></p>
<p class="fig-img1"><img alt="" class="image" src="images/ufig_1.jpg"/></p>
<p class="noindent1">GDP (Gross Domestic Product) is an annual figure that values all of the goods and services produced by a country in that year. GDP is a very simple indicator of national wealth.</p>
<p class="noindenta">International Monetary Fund (IMF) projections for GDP in 2019 will be approximately:</p>
<p class="noindenta">European Union 22,328; United States 22,149; China 15,519; Japan 5,433; Germany 4,558; United Kingdom 3,704; France 3,393; India 3,182. <i>(Figures are in billions of US$)</i></p>
<p class="h2"><b>2011 Census UK Population</b></p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup>
<col width="25%"/>
<col width="75%"/>
</colgroup>
<tbody>
<tr>
<td align="left" valign="top"><p class="table-para">England</p></td>
<td align="left" valign="top"><p class="table-para1">53 million</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Scotland</p></td>
<td align="left" valign="top"><p class="table-para1">5.3 million</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Wales</p></td>
<td align="left" valign="top"><p class="table-para1">3.1 million</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Northern Ireland</p></td>
<td align="left" valign="top"><p class="table-para1">1.8 million</p></td>
</tr>
</tbody>
</table>
<p class="h2"><b>UK Population Breakdown – Military Service Groups</b></p>
<p class="noindent1"><i>UK Office for National Statistics (2011 census figures – figures rounded to the nearest hundred)</i></p>
<p class="fig-img1"><img alt="" class="image" src="images/ufig_2.jpg"/></p>
</a><p class="h2"><a id="page_7"></a><a id="page_8"><b>UK Area</b></a></p><a id="page_8">
<p class="noindentb"><i>(in square kilometres)</i></p>
<div class="table">
<table border="0" cellpadding="0" cellspacing="0" class="td" width="55%">
<colgroup>
<col width="60%"/>
<col width="40%"/>
</colgroup>
<tbody>
<tr>
<td align="left" valign="top"><p class="tab-para">England</p></td>
<td align="left" valign="top"><p class="tab-para1">130,423</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">Scotland</p></td>
<td align="left" valign="top"><p class="tab-para1">20,766</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">Wales</p></td>
<td align="left" valign="top"><p class="tab-para1">78,133</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">Northern Ireland</p></td>
<td align="left" valign="top"><p class="tab-para1">14,160</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-parab">Total</p></td>
<td align="left" valign="top"><p class="tab-para1b">243,482</p></td>
</tr>
</tbody>
</table>
</div>
<p class="noindentc"><i>Note:</i> Comparisons include Germany 356,854 sq kms and France 550,000 sq kms. The total area of the European Union is 4,324,782 sq kms. The United States is 9,826,630 sq kms; Canada 9,984,670 sq kms; China 9,640,821 sq kms; India 3,166,414 sq kms and Russia 17,098,242 sq kms.</p>
<p class="h1" id="h1.2"><span class="line"><b>GOVERNMENT</b></span></p>
<p class="noindenta">The executive government of the United Kingdom is vested nominally in the Crown, but for practical purposes in a committee of Ministers that is known as the Cabinet. The head of the ministry and leader of the Cabinet is the Prime Minister and for the implementation of policy, the Cabinet is dependent upon the support of a majority of the Members of Parliament in the House of Commons. Within the Cabinet, defence matters are the responsibility of the Secretary of State for Defence.</p>
<p class="noindenta"><b>National Security Council (NSC)</b> This council is where the UK Government decides on the national defence and security objectives and the best way in which these objectives can be met using national resources. The National Security Council is chaired by the Prime Minister, and generally meets weekly with representation from across the major Departments of State. The Secretary of State for Defence attends as does the Chief of the Defence Staff when the need arises.</p>
<p class="h1" id="h1.3"><span class="line"><b>MILITARY TASKS AND DEFENCE PLANNING ASSUMPTIONS OF THE UK’S ARMED FORCES</b></span></p>
<p class="noindenta">The 2010 Strategic Defence and Security Review (SDSR) stated that the contribution of the UK Armed Forces to the national security effort is defined by a number of Military Tasks (MT) and Defence Planning Assumptions (DPA).</p>
<p class="h2"><b>Military Tasks (MT)</b></p>
<p class="noindent1">The seven military tasks are:</p>
<div class="space">
<p class="list-para">♦  Defending the UK and its Overseas Territories</p>
<p class="list-para">♦  Providing strategic intelligence</p>
<p class="list-para">♦  Providing nuclear deterrence</p>
<p class="list-para">♦  Supporting civil emergency organisations in times of crisis</p>
<p class="list-para">♦  Defending the UK’s interest by projecting power strategically and through expeditionary intervention</p>
<p class="list-para">♦  Providing a defence contribution to UK influence</p>
<p class="list-para">♦  Providing security for stabilisation</p>
</div>
<p class="h2"><b>Defence Planning Assumptions (DPA)</b></p>
<p class="noindent1">These assume that in the future the UK Armed Forces will have the size and shape that will enable them to conduct operations of the following type:</p>
<p class="noindenta">An enduring stabilisation operation at around brigade level (possibly up to 6,500 personnel) with maritime and air support as required, while also conducting:</p>
<p class="noindenta">One non-enduring complex intervention (up to 2,000 personnel), and<br/>One non-enduring simple intervention (up to 1,000 personnel):</p>
</a><p class="noindenta"><a id="page_8"></a><a id="page_9"><i>or alternatively:</i></a></p><a id="page_9">
<p class="noindenta">Three non-enduring operations if the UK Armed Forces are not already engaged in an enduring operation:</p>
<p class="noindenta"><i>or</i></p>
<p class="noindenta">For a limited time period, and with sufficient warning, committing all the UK’s effort to a one-off intervention of up to three brigades with air and maritime support at a level of about 30,000 personnel.</p>
<p class="noindenta">Having largely worked through the effects of the restructuring and budgetary cuts imposed by the 2010 Strategic Defence and Security Review (SDSR) the UK Armed Forces await the publication of the 2015 SDSR with analysts expecting some reductions in the UK’s defence capability. However, we believe that recent events in the Ukraine and the Middle East have prompted an urgent ‘across the board’ rethink of the global threat and it is possible that any further reductions are unlikely.</p>
<p class="h1" id="h1.4"><span class="line"><b>FUTURE FORCE 2020</b></span></p>
<p class="noindenta">In general terms the planning framework provided by the Military Tasks and Defence Planning Assumptions provides an outline for structure which the UK Government aims to establish by 2020. The proposal is for the Future Force 2020 to have three main combined service elements:</p>
<div class="space">
<p class="list-para">♦  The Deployed Force</p>
<p class="list-para">♦  The High Readiness Force</p>
<p class="list-para">♦  The Lower Readiness Force</p>
</div>
<p class="noindenta">This force will consist of 82,000 trained regular personnel and 30,000 trained reserves – an army consisting of 112,000 personnel.</p>
<p class="h2"><b>The Deployed Force</b></p>
<p class="noindent1">This will consist of those forces that are actually engaged in operations. Therefore aircraft engaged in operations (including the defence of the UK’s airspace), forces involved in operations in the South Atlantic, forces operating in support of friendly nations and other expeditionary operations, plus the nuclear deterrent will all form elements of The Deployed Force.</p>
<p class="h2"><b>The High Readiness Force</b></p>
<p class="noindent1">This force will consist of a range of maritime, air and land based units capable of deploying at short notice to meet the requirements of the Defence Planning Assumptions. Such forces would enable the UK to react quickly to a range of scenarios that might threaten our national security interests. These force elements would be capable of operating with allies or where necessary on ‘stand-alone’ UK operations.</p>
<p class="noindenta">The High Readiness Force will include an enhanced Special Forces capability.</p>
<p class="noindenta">In the main Joint Forces Command will have operational control of the majority of future High Readiness Force (Deployed Force) operations.</p>
<p class="h2"><b>The Lower Readiness Force</b></p>
<p class="noindent1">The Lower Readiness Force would consist of elements that have either recently returned from operations, or those that are preparing and training for inclusion in The High Readiness Force. Many Lower Readiness Force units (especially logistic) would be involved in supporting The Deployed Force on operations.</p>
</a><p class="h2"><a id="page_9"></a><a id="page_10"><b>Land Forces</b></a></p><a id="page_10">
<p class="noindent1">Land force capabilities will be based around eleven brigades as follows:</p>
<p class="noindenta">A Reaction Force of three multi-role brigades in 3 (UK) Division each consisting of around 6,500 personnel that are comprised of main battle tanks, armoured reconnaissance units, armoured, mechanised and light infantry elements, plus artillery, engineers, army aviation units in support and a complete range of logistic support units. One brigade would always be part of the High Readiness Force and where necessary these brigades could be self supporting.</p>
<p class="noindenta">16 Air Assault Brigade would be the fourth brigade and would provide parachute and air assault units for rapid intervention operations at very short notice. This brigade would be self supporting for short duration operations.</p>
<p class="noindenta">All of the above could form part of a much larger organisation (possibly divisional size) under the command of a deployable UK divisional headquarters. For multinational operations the headquarters of the Allied Rapid Reaction Corps (HQ ARRC) would be available.</p>
<p class="noindenta">Another seven brigades in 1 (UK) Division. These brigades would be equipped at lighter scales and be composed of a mix of regular and reserve personnel. They would be at a lower state of readiness, and if required individual units could be attached to formations in the Reaction Force. Many of the units in these brigades would be able to provide ‘depth’ in any enduring operation.</p>
<p class="noindenta">The Royal Marines 3 Commando Brigade (a Royal Naval formation) would be available for Land Force operations as required.</p>
<p class="noindenta">There are plans for all UK Army units to have been withdrawn from their bases in Germany by 2020 (combat units should have been withdrawn by the end of 2016). A majority of land force units will be returned to the UK well before that date.</p>
<p class="h2"><b>Royal Navy</b></p>
<p class="noindent1">Under the terms of the Future Force 2020 proposals the Royal Navy will provide a continuous nuclear deterrent system at sea, maritime defence of the United Kingdom and defence of territories in the South Atlantic. Forces assigned to these roles will include:</p>
<p class="noindenta">The Vanguard submarine force equipped with Trident submarine launched inter-continental ballistic missiles. Current plans are for the Vanguard class submarines to be replaced in the late 2020s (with the first submarine possibly being delivered in 2028).</p>
<p class="noindenta">Seven Astute class nuclear powered hunter killer submarines equipped with Tomahawk land attack cruise missiles. Astute class submarines are capable of operating at sea indefinitely.</p>
<p class="noindenta">Two new aircraft carriers, one of which will be kept at extended readiness. The aircraft carrier at sea will be equipped with Joint Strike Fighters and a range of helicopters that (depending on the operational requirement) could include Apache attack helicopters and possibly Chinook and Merlin support helicopters.</p>
<p class="noindenta">A balanced surface fleet of 19 frigates and destroyers.</p>
<p class="noindenta">Up to 14 mine counter-measures vessels to be based on the existing Hunt and Sandown class vessels. In addition there will be an ice patrol ship and an oceanographic survey capability.</p>
<p class="noindenta">The Royal Marine’s 3 Commando Brigade will provide an important maritime response capability to the High Readiness Force. 3 Commando Brigade will be able to land significant forces anywhere in the world.</p>
<p class="noindenta">Strategic transport will be provided by a force of up to 6 x roll-on, roll-off ferries.</p>
<p class="noindenta">The Royal Fleet Auxiliary will continue to supply and refuel Royal Naval vessels at sea worldwide.</p>
</a><p class="h2"><a id="page_10"></a><a id="page_11"><b>Royal Air Force</b></a></p><a id="page_11">
<p class="noindent1">The Royal Air Force will continue to provide the air defence of the United Kingdom and territories in the South Atlantic. To meet this requirement, in the longer term, a fast jet force of both Eurofighter Typhoon and Joint Strike Fighter aircraft will provide air defence, precision ground attack and combat ISTAR capabilities.</p>
<p class="noindenta">In the short term elements of the Tornado fleet will be retained to support operations in Iraq and elsewhere should the operational requirement arise.</p>
<p class="noindenta">The Royal Air Force will also provide a fleet of strategic and tactical airlift aircraft based around approximately 7 x C-17, 22 x A400M and 14 x Airbus A330 tanker and transport aircraft. The Chinook helicopter fleet will be increased by 12 new aircraft and Merlin helicopters will be retained.</p>
<p class="noindenta">ISTAR capabilities will be enhanced to include a range of unmanned air systems that will complement existing manned aircraft. The UK may purchase 3 x KC-135 Joint Rivet signals intelligence aircraft to improve the existing ISTAR capability.</p>
<p class="h1" id="h1.5"><span class="line"><b>CURRENT FORCE LEVELS</b></span></p>
<p class="h2a"><b>Total British Armed Forces (mid 2015)</b></p>
<p class="noindent1">All Services: 160,460; Army 92,000; Royal Navy 33,450 (including about 7,000 Royal Marines); Royal Air Force 35,030. (Figures are for trained and untrained and includes small numbers of Full Time Reserves).</p>
<p class="noindenta">Army figure includes about 2,700 Gurkhas.</p>
<p class="noindenta">By 2020 Regular Forces levels are planned to be about: Army 82,000; Royal Navy 30,000; Royal Air Force 33,000.</p>
<p class="noindenta"><b>Reserves:</b> Army 20,480; Maritime 1,940; Royal Air Force 1,500. There are probably over 50,000 Regular Reserves who could be recalled in a major emergency.</p>
<p class="noindenta"><b>MOD Civilians</b>: 61,630 (mid 2015)</p>
<p class="noindenta"><b>Strategic Forces:</b> 4 x Vanguard Class submarines capable of carrying up to 16 x Trident II (D5) Submarine Launched Ballistic Missiles (SLBM) deploying with 40 x warheads per submarine. If necessary a D5 missile could deploy with 12 MIRV (multiple independently targetable re-entry vehicles). Future plans appear to be for a stockpile of 120 operationally ready warheads and 58 missile bodies. Strategic Forces are provided by the Royal Navy.</p>
<p class="noindenta">Current plans appear to be for the Vanguard Class submarines to be replaced in the ‘2030s’.</p>
<p class="noindenta"><b>Army:</b> 83,340 (trained strength mid 2015): 1 x Corps Headquarters (HQ ARRC – NATO Deployable HQ); 1 x Reaction Force Divisional HQ (1 x Headquarters plus 5 x Brigades including 1 x Air Assault Brigade and 1 x Logistic Brigade); 1 x Adaptable Force Divisional HQ (1 x Headquarters plus 8 x Brigades including 1 x Logistic Brigade); Force Troops Command (1 x Headquarters plus 8 Brigades); 8 x Regional Headquarters; 1 x District HQ (London District).</p>
<p class="noindenta">These figures include:</p>
<p class="noindenta"><b>Formations:</b> 3 x Armoured Infantry Brigades, 1 x Air Assault Brigade; 7 x Regional Infantry Brigades; 3 x Logistics Brigades; 1 x Artillery Brigade; 1 x Engineer Brigade; 2 x Signal Brigades; 1 x Medical Brigade; 1 x Intelligence &amp; Surveillance Brigade; 1 x Military Police Brigade.</p>
<p class="noindenta"><b>Major Units:</b> 9 x Armoured Regiments; 31 x Infantry Battalions (plus 1 x public duties company); 13 x Artillery Regiments; 10 x Engineer Regiments/Major Units; 11 x Signal Regiments; 4 x Army Air Corps Regiments; 6 x Equipment Support Battalions; 12 x Logistic Regiments; 9 x Medical Regiments/Field Hospitals; 3 x Intelligence Battalions; 4 x Military Police Regiments.</p>
</a><p class="noindenta"><a id="page_11"></a><a id="page_12"><b>Major Royal Navy Elements:</b> 30,200 (trained strength – mid 2015 – including some 7,000 Royal Marines): 4 x Nuclear Powered Ballistic Missile firing (UK Strategic Deterrent); 6 x Nuclear Powered Submarines (attack type); 4 x Amphibious Assault Ships; 6 x Destroyers; 13 x Frigates (future combined total of 19); 15 x Minehunters and Minesweepers (future total of 14); 9 x Fleet Air Arm Squadrons (front line); <i>New construction:</i> 5 x Nuclear Attack Submarines; 2 x Aircraft Carriers. 6 x Destroyers Planned to enter service from 2018).</a></p><a id="page_12">
<p class="noindenta"><b>Royal Marines:</b> 7,000; 1 x Commando Brigade Headquarters; 3 x Royal Marine Commando (Battalion Size); 2 x Commando Assault Helicopter Squadrons; 1 x Commando Regiment Royal Artillery (under command); 1 x Commando Squadron Royal Engineers (under command); 1 x Commando Logistic Regiment; 4 x Commando Assault Squadrons (Landing craft); 1 x Fleet Protection Group; 4 x Nuclear Security Guarding Squadrons; 4 x Special Boat Service Squadrons.</p>
<p class="noindenta"><b>Major Royal Air Force Elements</b>: 32,180 (trained strength – early 2015) ; 11 x Strike/Attack/Fast Jet Squadrons; 2 x Unmanned Air Vehicle (UAV) Squadrons; 2 x Airborne Early Warning Squadrons; 2 x ISTAR Squadrons; 5 x Transport Squadrons; 3 x Air to Air Refuelling Squadrons; 7 x Support Helicopter Squadrons; 2 x Search and Rescue Squadrons; 8 x Ground (Field) Defence Squadrons (RAF Regiment). With the following aircraft (numbers approximate): 112 x Typhoon (total of 160 on order); 90 x Tornado GR4/4A; 60 x Hawk (all types); 12 x Voyager (total of 14 on order; 4 x Sentry AEW; 3 x Sentinel; 5 x Shadow R1; 24 x Hercules C1/3/4/5 8 x C-17; 5 x Reaper; 52 x Chinook (JFH); 24 x Puma (JFH); 22 x A400M Atlas will replace Hercules C1/C3 later in the decade; RAF Chinook and Puma helicopters are assigned to the Joint Force Helicopter (JFH); RAF Merlin helicopters were transferred to the Royal Navy’s Commando Helicopter Force in 2014.</p>
<p class="noindenta"><b>Joint Forces:</b> 1 x Joint Forces Command HQ; <b>Joint Helicopter Command:</b> 4 x Royal Naval Helicopter Squadrons; 4 x Army Aviation Regiments (already listed in the above Army entry plus 1 x Reserve Regiment); 7 x Royal Air Force Helicopter Squadrons (including 1 x RAuxAF Helicopter Support Squadron). <b>Joint Special Forces Group:</b> 1 x Regular Special Air Service (SAS) Regiment; 2 x Volunteer Reserve Special Air Service Regiments; 4 x Special Boat Service (SBS) Squadrons; 1 x Special Reconnaissance Regiment; 1 x Special Forces Support Group; 1 x Joint Special Forces Air Wing; <b>NBC:</b> Defence CBRN Wing: <b>Defence Medical Services:</b> Ministry of Defence Hospital Units; The Royal Centre for Defence Medicine: The Defence Medical Rehabilitation Centre (Headley Court); Defence Medical Services Training Centre; Defence Dental Services; Defence Medical Postgraduate Deanery.</p>
<p class="noindenta">National Police Forces: England and Wales 128,000 Scotland 17,000, Northern Ireland 7,200.</p>
<p class="h1" id="h1.6"><span class="line"><b>BRITISH ARMY EQUIPMENT SUMMARY</b></span></p>
<p class="noindent1"><b>Armour:</b> 227 x Challenger 2 (MBT).</p>
<p class="noindent1"><b>AIFV</b>: 400 x MCV 80 Warrior.</p>
<p class="noindent1"><b>APC:</b> 800 x Fv 432/430 family (Bulldog); (possibly 100 more available); 300 x Spartan; 115 x Warthog.</p>
<p class="noindent1"><b>PPV:</b> 400 x Mastiff; 400 x Foxhound; 179 x Vector; 125 x Wolfhound; 350 x Husky; 100 x Ridgeback.</p>
<p class="noindent1"><b>CLV:</b> 400 x Panther.</p>
<p class="noindent1"><b>Recce:</b> 220 x Scimitar; 11 x Fuchs (NBC); approx 200 Jackal (all types).</p>
<p class="noindent1"><b>Anti Tank</b>: 1,500+ x Javelin; possibly 20 x Spike (some SP).</p>
<p class="noindent1"><b>Artillery and Mortars:</b> 90 x 155 mm AS 90 (probably at least 50 in store); 50 x 227 mm MLRS/GLMRS; 100 x 105 mm Light Gun; 400 x 81 mm mortar (including about 100 x self-propelled); 1,000 x 51 mm Light Mortar.</p>
<p class="noindent1"><b>Air Defence:</b> 24 x Rapier C Fire Units; 100 x Starstreak (LML); 60 x HVM (SP on Stormer).</p>
<p class="noindent1"><b>Army Aviation:</b> 66 x WAH-64D Apache; 30 Lynx Wildcat (plus 6 for light assault); 50 x Lynx AH 7/9; 35 x Gazelle; 6 x BN-2; 4 x EC 365N3.</p>
<p class="noindent1"><b>Engineer:</b> 80 x CRARRV; 40 x Warrior ARRV; 33 x Titan (AVLB); 33 x Trojan; 38 x M3 (SP Bridge); 60 x Terrier (AVRE)’</p>
<p class="noindent1"><b>UAV:</b> 30 x Watchkeeper (our estimate): 10 x Hermes 450 (our estimate).</p>
</a><p class="h1" id="h1.7"><a id="page_12"></a><a id="page_13"><span class="line"><b>MINISTRY OF DEFENCE (MoD)</b></span></a></p><a id="page_13">
<p class="noindenta">In 1963, the three independent service ministries (Admiralty, War Office and Air Ministry) were merged to form the present MoD.</p>
<p class="noindenta">The UK MoD is the government department that is responsible for all defence related aspects of UK National Policy. This large organisation, which directly affects the lives of about half a million servicemen, reservists and MoD employed civilians, is controlled by The Secretary of State for Defence.</p>
<p class="noindenta">The Secretary of State for Defence has the following principal deputies;</p>
<div class="space">
<p class="list-para">♦  Minister of State for the Armed Forces.</p>
<p class="list-para">♦  Minister of State for Defence Procurement.</p>
<p class="list-para">♦  Parliamentary Under Secretary of State and Minister for Personnel and Veterans.</p>
<p class="list-para">♦  Parliamentary Under Secretary of State and Minister for Reserves.</p>
<p class="list-para">♦  Parliamentary Under Secretary of State and the Lords Spokesman on Defence.</p>
</div>
<p class="noindenta">The Secretary of State for defence is assisted by two advisers, one a civilian and the other a senior military officer:</p>
<p class="noindenta"><b>Permanent Under Secretary of State (PUS):</b> The PUS is responsible for policy, finance and administration in the MoD. As the MoD’s Principal Accounting Officer he is personally responsible to Parliament for the expenditure of all public money voted to the MoD for Defence purposes. The PUS is the most senior civilian in the MoD.</p>
<p class="noindenta"><b>Chief of the Defence Staff (CDS):</b> The CDS acts as the professional head of the Armed Forces and he is the principal military adviser to both the Secretary of State and to the Government.</p>
<p class="noindenta">Both the PUS and the CDS have deputies; the Second Permanent Under Secretary of State (2nd PUS), and the Vice Chief of the Defence Staff (VCDS). The VCDS acts as the Chief Operating Officer in the Armed Forces Chain-of-Command.</p>
<p class="h1" id="h1.8"><span class="line"><b>DEFENCE COMMITTEES</b></span></p>
<p class="noindenta">In general terms defence is managed through a number of major committees that provide corporate leadership and strategic direction:</p>
<div class="space">
<p class="noindent1">Defence Council – chaired by the Secretary of State for Defence</p>
<p class="noindent1">Defence Board – chaired by the Permanent Secretary</p>
<p class="noindent1">Chiefs of Staff Committee – chaired by the CDS</p>
<p class="noindent1">Service Boards (Admiralty Board, Army Board and Air Force Board)</p>
</div>
<p class="h2"><b>Defence Council</b></p>
<p class="noindent1">The Defence Council is the senior committee which provides the legal basis for the conduct and administration of defence and this council is chaired by the Secretary of State for Defence. The Defence Council reflects the constitutional principle that the defence forces are commanded by a Member of Parliament. The composition of the Defence Council is as follows:</p>
</a><div class="space"><a id="page_13">
<p class="noindent1">Secretary of State for Defence.</p>
<p class="noindent1">Minister of State for the Armed Forces.</p>
<p class="noindent1">Minister of State for Defence Procurement.</p>
<p class="noindent1">Parliamentary Under Secretary of State and Minister for Defence Personnel and Veterans.</p>
<p class="noindent1">Parliamentary Under Secretary of State and Minister for Reserves.</p>
<p class="noindent1">Parliamentary Under Secretary of State and the Lords Spokesman on Defence.</p>
<p class="noindent1">Permanent Under Secretary of State</p>
<p class="noindent1">Chief of the Defence Staff</p>
<p class="noindent1">Vice-Chief of the Defence Staff</p>
</a><p class="noindent1"><a id="page_13"></a><a id="page_14">Chief of the Naval Staff and First Sea Lord</a></p><a id="page_14">
<p class="noindent1">Chief of the Air Staff</p>
<p class="noindent1">Chief of the General Staff</p>
<p class="noindent1">Chief of Defence Materiel</p>
<p class="noindent1">Chief Scientific Adviser</p>
<p class="noindent1">Director General Finance</p>
<p class="noindent1">Second Permanent Under-Secretary of State for Defence</p>
</a></div><a id="page_14">
<p class="h2"><b>Defence Board</b></p>
<p class="noindent1">Chaired by the Secretary of State for Defence this board is the MoD’s main corporate board providing senior leadership and direction to the implementation of defence policy. It is responsible for the full range of Defence business other than the conduct of military operations.</p>
<p class="noindenta">The current membership of the Defence Board is:</p>
<div class="space">
<p class="noindent1">Secretary of State for Defence.</p>
<p class="noindent1">Minister of State for the Armed Forces.</p>
<p class="noindent1">Permanent Under Secretary.</p>
<p class="noindent1">Chief of the Defence Staff.</p>
<p class="noindent1">Vice Chief of the Defence Staff.</p>
<p class="noindent1">Chief Executive Defence Equipment and Support.</p>
<p class="noindent1">Director General Finance.</p>
<p class="noindent1">Audit Committee Chair (Non Executive Director).</p>
<p class="noindent1">Investment Approvals Committee Chair (Non Executive Director).</p>
<p class="noindent1">Appointments Committee Chair (Non Executive Director).</p>
</div>
<p class="noindenta">The MoD describes the objectives of the Defence Board’s core tasks as follows:</p>
<div class="space">
<p class="list-para">♦  Role of Defence: To help define and articulate the Department’s strategic direction, and provide a clear vision and set of values for defence.</p>
<p class="list-para">♦  Targets and Objectives: To establish the key priorities and defence capabilities needed to deliver the strategy.</p>
<p class="list-para">♦  Resource Allocation: To ensure that Defence priorities and tasks are appropriately resourced.</p>
<p class="list-para">♦  Performance Management: To manage corporate performance and resources in-year to deliver the required results.</p>
</div>
<p class="noindenta">The Defence Board is supported by three sub-committees:</p>
<div class="space">
<p class="list-para">♦  The Defence Audit Committee.</p>
<p class="list-para">♦  The Investment Approvals Committee</p>
<p class="list-para">♦  The People (Personnel) Committee.</p>
</div>
<p class="h2"><b>Chiefs of Staff Committee</b></p>
<p class="noindent1">This committee is chaired by the CDS and is the MoD’s senior committee that allows the CDS to gather information and advice from the single service chiefs of staff on operational matters and the preparation and conduct of military operations.</p>
<p class="h2"><b>Single Service Boards</b></p>
<p class="noindent1">There are three single service boards: Admiralty Board, Army Board and the Air Force Board all of which are chaired by the Secretary of State for Defence. In general the purpose of the boards is the administration and monitoring of single service performance. Each of these three boards has an executive committee chaired by the single service chief of staff; Navy Board, Executive Committee of the Army Board and the Air Force Board Standing Committee.</p>
</a><p class="h1" id="h1.9"><a id="page_14"></a><a id="page_15"><span class="line"><b>MOD HEAD OFFICE</b></span></a></p><a id="page_15">
<p class="noindenta">The MoD Head Office allocates resources to Top Level Budget Holders (TLB) who are then accountable to the Chief of the Defence Staff and the Permanent Under Secretary. TLB holders are responsible for the way in which their resources are allocated.</p>
<p class="noindenta">There are seven TLB holders:</p>
<div class="space">
<p class="list-para">♦  MoD Head Office &amp; Corporate Services</p>
<p class="list-para">♦  Land Command</p>
<p class="list-para">♦  Navy Command</p>
<p class="list-para">♦  Air Command</p>
<p class="list-para">♦  Joint Forces Command</p>
<p class="list-para">♦  Defence Equipment &amp; Support</p>
<p class="list-para">♦  Defence Infrastructure Organisation</p>
</div>
<p class="noindenta">In general terms the Head Office structure resembles the following:</p>
<p class="fig-img2"><img alt="" class="image" src="images/ufig_3.jpg"/></p>
<p class="h1" id="h1.10"><span class="line"><b>CHIEF OF THE DEFENCE STAFF</b></span></p>
<p class="noindenta">The Chief of the Defence Staff (CDS) is the officer responsible to the Secretary of State for Defence for the coordinated effort of all three fighting services. He has his own Central Staff Organisation and a Vice Chief of the Defence Staff who ranks as number four in the services hierarchy, following the three single service commanders. The current Chief of the Defence Staff is:</p>
<p class="h1" id="h1.11"><span class="line"><b>GENERAL SIR NICHOLAS HOUGHTON GCB CBE ADC GEN</b></span></p>
<p class="noindenta">General Nick Houghton was born in 1954 in Otley, West Yorkshire. He was educated at Woodhouse Grove School in Bradford, RMA Sandhurst and St Peter’s College, Oxford, where he completed an inservice degree in Modern History.</p>
<p class="noindenta">Commissioned into the Green Howards in 1974, he had a variety of Regimental and Staff appointments before attending the Army Command and Staff Courses at both Shrivenham and Camberley. Thereafter he was Military Assistant to the Chief of Staff British Army of the Rhine and a member of the Directing Staff at the Royal Military College of Science, Shrivenham. At Regimental Duty he was both a Company Commander in, and Commanding Officer of, 1st Battalion The Green Howards in the Mechanised and Airmobile roles, and in Northern Ireland.</p>
</a><p class="noindenta"><a id="page_15"></a><a id="page_16">General Houghton was Deputy Assistant Chief of Staff, G3 (Operations &amp; Deployment) in HQ Land Command 1994–1997 and attended the Higher Command and Staff Course in 1997. He commanded 39 Infantry Brigade in Northern Ireland from 1997 to 1999 and was the Director of Military Operations in the Ministry of Defence from December 1999 to July 2002.</a></p><a id="page_16">
<p class="noindenta">He was Chief of Staff of the Allied Rapid Reaction Corps from July 2002 to April 2004 before becoming the Assistant Chief of the Defence Staff (Operations) from May 2004 to October 2005. He was the Senior British Military Representative Iraq and Deputy Commanding General of the Multi-National Force-Iraq from October 2005 until assuming the appointment as Chief of Joint Operations at PJHQ (UK) in March 2006.</p>
<p class="noindenta">From 2009 General Houghton was the Vice Chief of the Defence Staff and in July 2013 he became the Chief of the Defence Staff.</p>
<p class="fig-img"><img alt="" class="image" src="images/ufig_4.jpg"/></p>
<p class="fig-caption"><i>General J N R Houghton GCB, CBE, ADC Gen. <span class="fig-caption1">(MoD Crown Copyright 2015)</span></i></p>
<p class="h2"><b>Vice Chief of the Defence Staff</b></p>
<p class="noindent1">Where appropriate the Vice Chief of the Defence Staff deputises for the Chief of the Defence Staff. On a day to day basis he is responsible through the Central Staff for running defence business (with the Second Permanent Under-Secretary).</p>
<p class="noindenta">As of May 2013 the Vice Chief of the Defence Staff is Air Chief Marshal Sir Stuart Peach who was previously Chief of Joint Operations/Commander Joint Forces Command.</p>
<p class="h1" id="h1.12"><span class="line"><b>CHAIN OF COMMAND</b></span></p>
<p class="noindenta">The Chief of the Defence Staff (CDS) commands and coordinates the activities of the three services through the following chain of command:</p>
<p class="fig-img2"><img alt="" class="image" src="images/ufig_5.jpg"/></p>
</a><p class="noindenta"><a id="page_16">The three single service commanders exercise command and control of their services through their respective headquarters. However, the complex inter-service nature of the majority of modern military operations, where military, air and naval support must be coordinated, resulted in the establishment in April 2012 of Joint Forces Command (JFC). More detail regarding the JFC can be found in </a><span href="#/xhtml/08_Chapter04" title="Link target outside of Sample">Chapter 4</span>.</p>
<p class="h1" id="h1.13"><a id="page_17"><span class="line"><b>DEFENCE EQUIPMENT AND SUPPORT (DE&amp;S)</b></span></a></p><a id="page_17">
<p class="noindenta">Following the establishment of PJHQ (now Joint Forces Command) at Northwood it became important to combine the separate logistics functions of the three armed forces. As a result, in 2000 the three distinct separate service logistic functions were fused into one and the Defence Logistic Organisation was formed.</p>
</a><p class="noindenta"><a id="page_17">From 1 April 2007 the Defence Procurement Agency (DPA) and the Defence Logistic Organisation (DLO) were merged to form Defence Equipment and Support (DE&amp;S). More detail regarding the DE&amp;S can be found in </a><span href="#/xhtml/08_Chapter04" title="Link target outside of Sample">Chapter 4</span>.</p>
<p class="h1" id="h1.14"><span class="line"><b>THE UNITED KINGDOM AND DEFENCE FINANCE</b></span></p>
<div class="disp-quote">
<p class="center">“You need three things to win a war,<br/>Money, money and more money”.</p>
<p class="right"><i>Trivulzio (1441–1518)</i></p>
</div>
<p class="noindenta">In general terms defence is related to money, and a nation’s ability to pay for its defence is linked to its GDP (Gross Domestic Product) as measured by the sum of all economic activity within a country. Estimates for the world’s top ten GDP rankings for 2014 (in billions of US$) and the latest year for which accurate (International Monetary Fund) figures are available are as follows:</p>
<p class="noindent">GDP 2014 <i>(US$ billions)</i></p>
<div class="table">
<table border="0" cellpadding="0" cellspacing="0" class="td" width="70%">
<colgroup>
<col width="45%"/>
<col width="55%"/>
</colgroup>
<tbody>
<tr>
<td align="left" valign="top"><p class="tab-para">European Union</p></td>
<td align="left" valign="top"><p class="tab-para1">18,451 (<a href="#/xhtml/#fn1" id="ft1">1</a>)</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">United States</p></td>
<td align="left" valign="top"><p class="tab-para1">17,426</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">China</p></td>
<td align="left" valign="top"><p class="tab-para1">10,335</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">Japan</p></td>
<td align="left" valign="top"><p class="tab-para1">4,770</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">Germany</p></td>
<td align="left" valign="top"><p class="tab-para1">3,820</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">France</p></td>
<td align="left" valign="top"><p class="tab-para1">2,902</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">United Kingdom</p></td>
<td align="left" valign="top"><p class="tab-para1">2,838</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">Brazil</p></td>
<td align="left" valign="top"><p class="tab-para1">2,244</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">Italy</p></td>
<td align="left" valign="top"><p class="tab-para1">2,159</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-parab">Russia</p></td>
<td align="left" valign="top"><p class="tab-para1b">2,050</p></td>
</tr>
</tbody>
</table>
<p class="tab-fn"><i>Note:</i></p>
<p class="fn-list">(<a href="#/xhtml/#ft1" id="fn1">1</a>) This is the sum total of the GDP of all 28 European Union nations.</p>
</div>
<p class="h1" id="h1.15"><span class="line"><b>UK DEFENCE EXPENDITURE</b></span></p>
<p class="noindenta">In the 2015–2016 Financial Year (FY) the UK Government plans to spend £34.8 billion on defence.</p>
<p class="noindenta">For comparison purposes defence expenditure is often expressed as a percentage of GDP. Expenditure in FY 2015–2016 will represent just over 2 per cent of GDP. In 1985 UK defence expenditure represented 5.2 per cent of GDP.</p>
<p class="noindenta">The estimated total UK government expenditure for FY 2015–2016 is £747 billion.</p>
<p class="noindenta">Major spending departments include:</p>
<div class="table1">
<table border="0" cellpadding="0" cellspacing="0" width="75%">
<colgroup>
<col width="90%"/>
<col width="10%"/>
</colgroup>
<tbody>
<tr>
<td align="left" valign="top"><p class="table-para">Department for Work and Pensions</p></td>
<td align="right" valign="top"><p class="table-para1">£155 billion</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Department of Health</p></td>
<td align="right" valign="top"><p class="table-para1">£135 billion</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Social Security</p></td>
<td align="right" valign="top"><p class="table-para1">£112 billion</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Department for Children, Schools and Families</p></td>
<td align="right" valign="top"><p class="table-para1">£92 billion</p></td>
</tr>
</tbody>
</table>
</div>
<p class="noindenta"><a id="page_18">Some interesting comparisons can be made when looking at estimates for the world’s top defence budgets for 2014 (in billions of US$ (and the latest year for which accurate figures are available) are as follows:</a></p><a id="page_18">
<p class="noindent">Defence Budgets 2014 <i>(US$ billions)</i></p>
<div class="table">
<table border="0" cellpadding="0" cellspacing="0" class="td" width="70%">
<colgroup>
<col width="60%"/>
<col width="40%"/>
</colgroup>
<tbody>
<tr>
<td align="left" valign="top"><p class="tab-para">United States</p></td>
<td align="left" valign="top"><p class="tab-para1">581 billion</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">China</p></td>
<td align="left" valign="top"><p class="tab-para1">129 billion</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">Saudi Arabia</p></td>
<td align="left" valign="top"><p class="tab-para1">81 billion</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">Russia</p></td>
<td align="left" valign="top"><p class="tab-para1">70 billion</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">United Kingdom</p></td>
<td align="left" valign="top"><p class="tab-para1">62 billion</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">France</p></td>
<td align="left" valign="top"><p class="tab-para1">53 billion</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">Japan</p></td>
<td align="left" valign="top"><p class="tab-para1">48 billion</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">Germany</p></td>
<td align="left" valign="top"><p class="tab-para1">44 billion</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-parab">India</p></td>
<td align="left" valign="top"><p class="tab-para1b">37 billion</p></td>
</tr>
</tbody>
</table>
</div>
<p class="h1" id="h1.16"><span class="line"><b>UK – TOP LEVEL BUDGETS</b></span></p>
<p class="noindenta">Under the early 1990s ‘New Management Strategy’ the UK defence budget was allocated to a series of ‘Top Level Budget Holders’ each of whom were allocated a budget with which to run their departments. The money allocated to these Top Level Budgets (TLBs) constitutes the building bricks upon which the whole of the defence budget is based.</p>
<p class="noindenta">As previously stated there are seven Level Budget holders and the last figure we can identify relating to actual TLB expenditure is for Financial Year (FY 2012–2013):</p>
<div class="table1">
<table border="0" cellpadding="0" cellspacing="0" width="60%">
<colgroup>
<col width="75%"/>
<col width="25%"/>
</colgroup>
<tbody>
<tr>
<td align="left" valign="top"><p class="table-para">Royal Navy Command</p></td>
<td align="left" valign="top"><p class="table-para1">– £3.93 billion</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Army Command</p></td>
<td align="left" valign="top"><p class="table-para1">– £7.97 billion</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Air Command</p></td>
<td align="left" valign="top"><p class="table-para1">– £4.03 billion</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Joint Forces Command</p></td>
<td align="left" valign="top"><p class="table-para1">– £0.32 billion</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Defence Equipment and Support</p></td>
<td align="left" valign="top"><p class="table-para1">– £11.29 billion</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Defence Infrastructure Organisation</p></td>
<td align="left" valign="top"><p class="table-para1">– £3.33 billion</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Head Office and Corporate Services</p></td>
<td align="left" valign="top"><p class="table-para1">– £2.09 billion</p></td>
</tr>
</tbody>
</table>
</div>
<p class="noindenta"><i>Note:</i> Army Command TLB includes Service Children’s Education; Defence Equipment &amp; Support TLB includes Defence Storage and Distribution Agency; Central TLB includes Defence Vetting Agency, MoD Police and Guarding Agency, People Pay and Pensions Agency and Service Personnel and Veterans Agency.</p>
<p class="noindenta">Within the TLBs, there are approximately 29 reporting entities, known as management groupings, producing detailed management accounting information as part of the annual financial management.</p>
<p class="noindenta">In addition to the major TLBs there are three Trading Funds as follows: Defence Support Group, Defence Science and Technology Laboratory, Hydrographic Office.</p>
<p class="h1" id="h1.17"><span class="line"><b>THE DEFENCE EQUIPMENT PLAN</b></span></p>
<p class="noindenta">Over the 10 year period from April 2014 to April 2024 the MoD plans to spend £163 billion on defence equipment.</p>
</a><p class="noindent"><a id="page_18"></a><a id="page_19">MoD Equipment Budget 2014–2024 (<i>£ billions)</i></a></p><a id="page_19">
<div class="table">
<table border="0" cellpadding="0" cellspacing="0" class="td" width="67%">
<colgroup>
<col width="60%"/>
<col width="40%"/>
</colgroup>
<tbody>
<tr>
<td align="left" valign="top"><p class="tab-para">Ships</p></td>
<td align="left" valign="top"><p class="tab-para1">18.2</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">Submarines</p></td>
<td align="left" valign="top"><p class="tab-para1">40.0</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">Land Equipment</p></td>
<td align="left" valign="top"><p class="tab-para1">15.4</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">Weapons</p></td>
<td align="left" valign="top"><p class="tab-para1">12.6</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">Combat Air</p></td>
<td align="left" valign="top"><p class="tab-para1">17.9</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">Air Support</p></td>
<td align="left" valign="top"><p class="tab-para1">13.8</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">Helicopters</p></td>
<td align="left" valign="top"><p class="tab-para1">11.1</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">ISTAR</p></td>
<td align="left" valign="top"><p class="tab-para1">4.9</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-para">Information Systems &amp; Services</p></td>
<td align="left" valign="top"><p class="tab-para1">16.9</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="tab-parab">Other Support</p></td>
<td align="left" valign="top"><p class="tab-para1b">6.6</p></td>
</tr>
</tbody>
</table>
</div>
<p class="noindent">Some of the total programme costs for a selection of the MoD’s major equipment programmes are amongst the following:</p>
<div class="table1">
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup>
<col width="30%"/>
<col width="40%"/>
<col width="30%"/>
</colgroup>
<tbody>
<tr>
<td align="left" valign="top"><p class="table-para">A400M</p></td>
<td align="left" valign="top"><p class="table-para1">Large transport aircraft</p></td>
<td align="left" valign="top"><p class="table-para1">£2.7 billion</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Astute Class</p></td>
<td align="left" valign="top"><p class="table-para1">Attack submarines</p></td>
<td align="left" valign="top"><p class="table-para1">£9.4 billion</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Strategic Tanker</p></td>
<td align="left" valign="top"><p class="table-para1">Air-to-air refuelling &amp; passengers</p></td>
<td align="left" valign="top"><p class="table-para1">£11.4 billion</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Lightning II</p></td>
<td align="left" valign="top"><p class="table-para1">Fighter/attack aircraft</p></td>
<td align="left" valign="top"><p class="table-para1">£5.0 billion</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Queen Elizabeth Class</p></td>
<td align="left" valign="top"><p class="table-para1">Aircraft carriers</p></td>
<td align="left" valign="top"><p class="table-para1">£6.1 billion</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Scout Vehicle</p></td>
<td align="left" valign="top"><p class="table-para1">Armoured fighting vehicle</p></td>
<td align="left" valign="top"><p class="table-para1">£1.4 billion</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Typhoon</p></td>
<td align="left" valign="top"><p class="table-para1">Fighter aircraft</p></td>
<td align="left" valign="top"><p class="table-para1">£18.2 billion</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Warrior</p></td>
<td align="left" valign="top"><p class="table-para1">Capability sustainment programme</p></td>
<td align="left" valign="top"><p class="table-para1">£1.3 billion</p></td>
</tr>
</tbody>
</table>
</div>
<p class="noindenta">The high unit costs of individual items of equipment also serves to illustrate the problems faced by defence planners when working out their annual budgets. Some of the following prices illustrate the costs:</p>
<div class="table1">
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup>
<col width="48%"/>
<col width="52%"/>
</colgroup>
<tbody>
<tr>
<td align="left" valign="top"><p class="table-para">Storm Shadow (Air to Ground) Missile)</p></td>
<td align="left" valign="top"><p class="table-para1">– £500,000</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Kinetic Energy Round for Challenger</p></td>
<td align="left" valign="top"><p class="table-para1">– £3,500 each</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">155 mm High Explosive Round</p></td>
<td align="left" valign="top"><p class="table-para1">– £900 each</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Individual Weapon (IW)</p></td>
<td align="left" valign="top"><p class="table-para1">– £800 each (estimate)</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">5.56 mm round for IW</p></td>
<td align="left" valign="top"><p class="table-para1">– £1.25</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Tomahawk Cruise Missile (Block IV)</p></td>
<td align="left" valign="top"><p class="table-para1">– £600,000</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">One Rapier Missile</p></td>
<td align="left" valign="top"><p class="table-para1">– £60,000</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">One Challenger 2 MBT</p></td>
<td align="left" valign="top"><p class="table-para1">– £4.5 million (approx)</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Combat High Boot</p></td>
<td align="left" valign="top"><p class="table-para1">– £95 per pair</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Starstreak Missile</p></td>
<td align="left" valign="top"><p class="table-para1">– £110,000 each</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Attack Helicopter</p></td>
<td align="left" valign="top"><p class="table-para1">– £42 million (region)</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Eurofighter</p></td>
<td align="left" valign="top"><p class="table-para1">– £60 million (estimate)</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Merlin Support Helicopter</p></td>
<td align="left" valign="top"><p class="table-para1">– £34 million</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">F-35B Lightning II</p></td>
<td align="left" valign="top"><p class="table-para1">– £90 million (recent estimate)</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Panther CLV</p></td>
<td align="left" valign="top"><p class="table-para1">– £500,000</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Astute Class Submarine</p></td>
<td align="left" valign="top"><p class="table-para1">– £1.3 billion (average cost)</p></td>
</tr>
</tbody>
</table>
</div>
<p class="noindenta">Another interesting table shows the relationship between the defence budget and the numbers of active service personnel in a number of selected countries.</p>
</a><p class="fig-img1"><a id="page_19"></a><a id="page_20"><img alt="" class="image" src="images/ufig_6.jpg"/></a></p><a id="page_20">
<p class="h1" id="h1.18"><span class="line"><b>BRITISH ARMY STATISTICS</b></span></p>
<p class="h2a"><b>UK Armed Forces – Army (mid 2015) – Trained and Untrained Strength</b></p>
<p class="fig-img3"><img alt="" class="image" src="images/ufig_7.jpg"/></p>
<p class="noindent1">The Army 2020 plan calls for 82,000 trained regular personnel and 30,000 trained reserves – an army consisting of 112,000 personnel.</p>
<p class="h2"><b>UK Armed Forces – Army (mid 2015) – Trained Strength</b></p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup>
<col width="15%"/>
<col width="85%"/>
</colgroup>
<tbody>
<tr>
<td align="left" valign="top"><p class="table-para">Officers</p></td>
<td align="left" valign="top"><p class="table-para1">12,300 (includes 110 Gurkha officers)</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Soldiers</p></td>
<td align="left" valign="top"><p class="table-para1">71,040 (includes 2,540 Gurkhas)</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Total</p></td>
<td align="left" valign="top"><p class="table-para1">83,340 (3,950 under the requirement)</p></td>
</tr>
</tbody>
</table>
<p class="h2"><b>UK Armed Forces – Army (mid 2015) – Untrained strength</b></p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup>
<col width="15%"/>
<col width="85%"/>
</colgroup>
<tbody>
<tr>
<td align="left" valign="top"><p class="table-para">Officers</p></td>
<td align="left" valign="top"><p class="table-para1">760</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Soldiers</p></td>
<td align="left" valign="top"><p class="table-para1">5,860 (includes 70 Gurkhas)</p></td>
</tr>
</tbody>
</table>
<p class="h2"><b>UK Armed Forces – Army – Intake to the Training Organisation – (Year ending 31 Dec 2014)</b></p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup>
<col width="15%"/>
<col width="20%"/>
<col width="65%"/>
</colgroup>
<tbody>
<tr>
<td align="left" valign="top"><p class="table-para"> </p></td>
<td align="left" valign="top"><p class="table-para1">(2014)</p></td>
<td align="left" valign="top"><p class="table-para1">(1980/81)</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Officers</p></td>
<td align="left" valign="top"><p class="table-para1">540</p></td>
<td align="left" valign="top"><p class="table-para1">1,489</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Soldiers</p></td>
<td align="left" valign="top"><p class="table-para1">6,840</p></td>
<td align="left" valign="top"><p class="table-para1">27,382</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"> </p></td>
<td align="left" valign="top"><p class="table-para1"><b>7,380</b></p></td>
<td align="left" valign="top"><p class="table-para1"><b>28,871</b></p></td>
</tr>
</tbody>
</table>
<p class="noindenta"><i>Note:</i> 1980/81 figures are given for comparison.</p>
<p class="h2"><b>UK Armed Forces – Army – Outflow – Year ending 31 Dec 2014)</b></p>
<p class="fig-imga"><img alt="" class="image" src="images/ufig_8.jpg"/></p>
<p class="h2"><b>Strengths by Arm and Service</b></p>
<p class="noindent1">The following table is somewhat dated (mid 2012) but is the most recent available. Although dated, the table provides a rough guide to the approximate current strengths of the Arms and Services.</p>
<div class="table">
<table border="0" cellpadding="0" cellspacing="0" class="td" width="100%">
<colgroup>
<col width="65%"/>
<col width="35%"/>
</colgroup>
<tbody>
<tr>
<td align="left" class="td1" valign="top"><p class="table-th"><a id="page_21"><b>Trained regular personnel by arm and service</b></a></p></td>
<td align="left" class="td1" valign="top"><p class="table-th1"><b>Strength</b></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Staff</p></td>
<td align="left" valign="top"><p class="table-para1">760</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">The Household Cavalry/Royal Armoured Corps</p></td>
<td align="left" valign="top"><p class="table-para1">5,490</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Royal Regiment of Artillery</p></td>
<td align="left" valign="top"><p class="table-para1">7,330</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Corps of Royal Engineers</p></td>
<td align="left" valign="top"><p class="table-para1">9,840</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Royal Corps of Signals</p></td>
<td align="left" valign="top"><p class="table-para1">8,140</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">The Infantry</p></td>
<td align="left" valign="top"><p class="table-para1">25,840</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Army Air Corps</p></td>
<td align="left" valign="top"><p class="table-para1">2,000</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Royal Army Chaplains Department</p></td>
<td align="left" valign="top"><p class="table-para1">140</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">The Royal Logistics Corps</p></td>
<td align="left" valign="top"><p class="table-para1">14,760</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Royal Army Medical Corps</p></td>
<td align="left" valign="top"><p class="table-para1">3,000</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Royal Electrical and Mechanical Engineers</p></td>
<td align="left" valign="top"><p class="table-para1">9,660</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Adjutant General’s Corps</p></td>
<td align="left" valign="top"><p class="table-para1">6,120</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Royal Army Veterinary Corps</p></td>
<td align="left" valign="top"><p class="table-para1">370</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Small Arms School Corps</p></td>
<td align="left" valign="top"><p class="table-para1">160</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Royal Army Dental Corps</p></td>
<td align="left" valign="top"><p class="table-para1">340</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Intelligence Corps</p></td>
<td align="left" valign="top"><p class="table-para1">1,680</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Army Physical Training Corps</p></td>
<td align="left" valign="top"><p class="table-para1">460</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Queen Alexandra’s Royal Army Nursing Corps</p></td>
<td align="left" valign="top"><p class="table-para1">880</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-parab">Corps of Army Music</p></td>
<td align="left" valign="top"><p class="table-para1b">780</p></td>
</tr>
</tbody>
</table>
</div>
<p class="noindent"><b>Service Personnel Deployed in the UK (mid 2015):</b> 136,054</p>
<p class="h2"><b>Service Personnel Deployed/Stationed outside the UK mainland (Early 2015)</b></p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup>
<col width="25%"/>
<col width="75%"/>
</colgroup>
<tbody>
<tr>
<td align="left" valign="top"><p class="table-para">Germany</p></td>
<td align="left" valign="top"><p class="table-para1">– 10,550</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Ukraine</p></td>
<td align="left" valign="top"><p class="table-para1">– 35 (training mission)</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Cyprus</p></td>
<td align="left" valign="top"><p class="table-para1">– 2,420 (includes 300 UNFICYP)</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Gibraltar</p></td>
<td align="left" valign="top"><p class="table-para1">– 160</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Other Europe</p></td>
<td align="left" valign="top"><p class="table-para1">– 700</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Sierra Leone</p></td>
<td align="left" valign="top"><p class="table-para1">– 10 (+800 on temporary deployment)</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Kenya</p></td>
<td align="left" valign="top"><p class="table-para1">– 200</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Iraq</p></td>
<td align="left" valign="top"><p class="table-para1">– 145</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Saudi Arabia</p></td>
<td align="left" valign="top"><p class="table-para1">– 120</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Other Middle East</p></td>
<td align="left" valign="top"><p class="table-para1">– 140</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Belize/Caribbean</p></td>
<td align="left" valign="top"><p class="table-para1">– 10</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">South America</p></td>
<td align="left" valign="top"><p class="table-para1">– 10</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Australia</p></td>
<td align="left" valign="top"><p class="table-para1">– 40</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Canada</p></td>
<td align="left" valign="top"><p class="table-para1">– 270</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">USA</p></td>
<td align="left" valign="top"><p class="table-para1">– 590</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Afghanistan</p></td>
<td align="left" valign="top"><p class="table-para1">– 470 (Operation Resolute Support)</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Brunei</p></td>
<td align="left" valign="top"><p class="table-para1">– 700 (estimate – mainly Gurkhas)</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Falkland Islands</p></td>
<td align="left" valign="top"><p class="table-para1">– 1,200 (capable of rapid reinforcement)</p></td>
</tr>
</tbody>
</table>
<p class="h2"><b>Army Cadet Force (at 1 April 2014)</b></p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup>
<col width="25%"/>
<col width="75%"/>
</colgroup>
<tbody>
<tr>
<td align="left" valign="top"><p class="table-para">Total Army Cadets</p></td>
<td align="left" valign="top"><p class="table-para1">– 50,480 (includes 9,440 adult volunteers)</p></td>
</tr>
</tbody>
</table>
<p class="noindenta">The Army Cadets are run and administered by the MoD. There are another 45,760 in the Combined Cadet Force (CCF) that has Army, Navy and Royal Air Force contingents. CCF units are usually attached to schools</p>
</a><p class="h2"><a id="page_20"></a><a id="page_22"><b>Dogs and Horses</b></a></p><a id="page_22">
<p class="noindent1">During early 2015 we believe that there are about 550 military working dogs and 485 horses in service with the UK Armed Forces. There appear to be a further 400 dogs in service with the Ministry of Defence Police and other guarding agencies.</p>
<p class="h2"><b>Over 100 Years Ago – Strength of the British Army at 1 Jan 1905</b></p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup>
<col width="47%"/>
<col width="53%"/>
</colgroup>
<tbody>
<tr>
<td align="left" valign="top"><p class="table-para">Regular Army</p></td>
<td align="left" valign="top"><p class="table-para1">– 195,000</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Colonial Troops or Native Indian Corps</p></td>
<td align="left" valign="top"><p class="table-para1">– 14,000</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Army Reserve</p></td>
<td align="left" valign="top"><p class="table-para1">– 80,000</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Militia</p></td>
<td align="left" valign="top"><p class="table-para1">– 132,000</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Yeomanry (Cavalry)</p></td>
<td align="left" valign="top"><p class="table-para1">– 28,000</p></td>
</tr>
</tbody>
</table>
<p class="noindenta">Regular forces in India totalled 74,500.</p>
<p class="noindenta">The Indian Army totalled approximately 240,000 all ranks.</p>
<p class="noindenta">Three years previously Regular Army totals by Corps were:</p>
<div class="table1">
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup>
<col width="47%"/>
<col width="53%"/>
</colgroup>
<tbody>
<tr>
<td align="left" valign="top"><p class="table-para">Household Cavalry</p></td>
<td align="left" valign="top"><p class="table-para1">– 1,390</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Cavalry of the Line</p></td>
<td align="left" valign="top"><p class="table-para1">– 20,200</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Horse Artillery</p></td>
<td align="left" valign="top"><p class="table-para1">– 3,483</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Field Artillery</p></td>
<td align="left" valign="top"><p class="table-para1">– 15,509</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Mountain Artillery</p></td>
<td align="left" valign="top"><p class="table-para1">– 1,200</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Garrison Artillery</p></td>
<td align="left" valign="top"><p class="table-para1">– 18,400</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Royal Engineers</p></td>
<td align="left" valign="top"><p class="table-para1">– 7,130</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Foot Guards</p></td>
<td align="left" valign="top"><p class="table-para1">– 5,873</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Infantry of the Line</p></td>
<td align="left" valign="top"><p class="table-para1">– 132,332</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Colonial Corps</p></td>
<td align="left" valign="top"><p class="table-para1">– 5,217</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Army Service Corps</p></td>
<td align="left" valign="top"><p class="table-para1">– 3,555</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Ordnance Staff</p></td>
<td align="left" valign="top"><p class="table-para1">– 920</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Armourers</p></td>
<td align="left" valign="top"><p class="table-para1">– 352</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Medical Services</p></td>
<td align="left" valign="top"><p class="table-para1">– 2,993</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">Total</p></td>
<td align="left" valign="top"><p class="table-para1">– 218,554</p></td>
</tr>
</tbody>
</table>
</div>
<p class="noindenta">A force reduction was in place due to the drawdown following the end of the war in South Africa.</p>
</a></div><a id="page_22">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Chapter01.vue?0e762fc9